const ITEMS = [
  "PROOF OF CONSEQUENCE",
  "OUTCOME VERIFICATION",
  "REPUTATION PRIMITIVE",
  "AUTONOMOUS ECONOMIES",
  "VERIFIED TRACK RECORDS",
  "THE OUTCOME LAYER",
  "$CONSEQ",
];

/** Slow editorial marquee — one loop, two copies for seamless wrap. */
export function Marquee() {
  return (
    <div className="marquee-mask overflow-hidden border-y border-line bg-panel/60 py-4" data-testid="marquee-band">
      <div className="marquee-track flex w-max animate-marquee items-center gap-10 hover:[animation-play-state:paused]">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center gap-10" aria-hidden={copy === 1}>
            {ITEMS.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center gap-10 whitespace-nowrap">
                <span className="font-mono text-xs uppercase tracking-[0.3em] text-dim">{item}</span>
                <span className="text-[8px] text-cyan">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
